import { render, staticRenderFns } from "./xfmzConfigInfos.vue?vue&type=template&id=bdcde128&scoped=true"
import script from "./xfmzConfigInfos.vue?vue&type=script&lang=js"
export * from "./xfmzConfigInfos.vue?vue&type=script&lang=js"
import style0 from "./xfmzConfigInfos.vue?vue&type=style&index=0&id=bdcde128&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcde128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdcde128')) {
      api.createRecord('bdcde128', component.options)
    } else {
      api.reload('bdcde128', component.options)
    }
    module.hot.accept("./xfmzConfigInfos.vue?vue&type=template&id=bdcde128&scoped=true", function () {
      api.rerender('bdcde128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_gd_details/form/components/xfmzConfigInfos.vue"
export default component.exports